import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { Table } from "@td/ui";

const ListViewContainer = React.memo(({ className, ...props }) => (
  <Table
    {...props}
    className={classNames(styles.listViewContainer, className)}
    data-testid="list-view-container"
  />
));

ListViewContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default ListViewContainer;
